import { useEffect, useState, useContext } from "react";
import * as style from "./ElementosCSS";
import * as _f_ from "@Funciones/funciones";

import { Contexto } from "@Componentes/App";

/*
============================================================
Elementos V1 -> asucasaire -> Formulario
Los datos necesarios son conf(id,className,editable,visible), 
data, onChange,valorescampos,placeholder
============================================================
*/
function obtenerPropiedad(param, propiedad) {
  let propiedadFinal =
    propiedad === ""
      ? ""
      : param?.valdependencia === "" && param?.valexcluyente === ""
        ? ""
        : param?.valdependencia !== ""
          ? (param?.valdependencia).includes(param?.variables[propiedad])
            ? ""
            : "none"
          : !(param?.valexcluyente).includes(param?.variables[propiedad])
            ? ""
            : "none";
  // console.log(param?.data.placeholder,propiedadFinal)
  return propiedadFinal;
}

const comprimirImagen = (file, maxWidth = 1280, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // Redimensionar manteniendo proporción
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        const canvas = document.createElement("canvas");

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");

        ctx.drawImage(img, 0, 0, width, height);

        // Convertir a JPEG comprimido
        const base64 = canvas.toDataURL("image/jpeg", quality);

        resolve(base64);
      };

      img.onerror = reject;

      img.src = event.target.result;
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
};

export const InputCamaraBase64 = (param) => {
  const handleChange = async (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    try {
      const base64 = await comprimirImagen(
        file,
        1280, // ancho máximo
        0.7, // calidad JPEG
      );

      const evento = {
        target: {
          id: param?.conf?.id,
          className: param?.conf?.className,
          type: "cameraBase64",
          value: base64,
        },
      };

      if (param?.onChange) {
        param.onChange(evento);
      }
    } catch (error) {
      console.error("Error procesando imagen:", error);
    }
  };

  return (
    <div
      className="InputForm"
      style={{
        display:
          param?.varEditarVisible === 2
            ? param?.conf?.visible
              ? obtenerPropiedad(param, param?.varvisible)
              : "none"
            : !param?.conf?.visible
              ? "none"
              : "",

        gridColumn: param?.conf?.rellenaFila ? "1 / -1" : "",
      }}>
      <label htmlFor={param?.conf?.id}>{param?.data?.placeholder}</label>

      <input
        type="file"
        accept="image/*"
        capture="environment"
        id={param?.conf?.id}
        name={param?.conf?.id}
        className={param?.conf?.className}
        disabled={
          param?.varEditarVisible === 1
            ? param?.conf?.visible
              ? obtenerPropiedad(param, param?.varvisible)
              : true
            : !param?.conf?.editable
        }
        onChange={handleChange}
      />
    </div>
  );
};

export const InputTextForm = (param) => {
  return (
    <>
      <div
        className="InputForm"
        style={{
          display:
            param?.varEditarVisible === 2
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : "none"
              : !param.conf.visible,
          gridColumn: param?.conf?.rellenaFila ? "1 / -1" : "",
          // display: param?.conf.visible
          //   ? param?.varvisible === ""
          //       ? ""
          //       : param?.valdependencia==="" && param?.valexcluyente===""
          //         ? ""
          //         : param?.valdependencia!==""
          //           ? ((param?.valdependencia).includes(param?.variables[param?.varvisible]) ? "":"none")
          //           : (!(param?.valexcluyente).includes(param?.variables[param?.varvisible]) ? "":"none")
          //   : "none",
        }}>
        <label htmlFor={param.conf.id}>{param?.data.placeholder}</label>
        <input
          type="text"
          disabled={
            param?.varEditarVisible === 1
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : true
              : !param.conf.editable
          }
          // disabled={!param.conf.editable}
          {...(param?.conf.id ? { name: param.conf.id } : {})}
          {...(param?.conf.id ? { id: param.conf.id } : {})}
          {...(param?.conf.className ? { className: param.conf.className } : {})}
          {...(param?.conf.min ? { minLength: param.conf.min } : {})}
          {...(param?.conf.max ? { maxLength: param.conf.max } : {})}
          {...(param?.valorescampos
            ? { value: param.variables[param.conf.className] } //valorescampos id
            : {})}
          {...(param?.onChange ? { onChange: param.onChange } : {})}
          {...(param?.onBlur ? { onBlur: param.onBlur } : {})}
        />
      </div>
    </>
  );
};

export const InputNumberForm = (param) => {
  function limitarCifras() {
    let input = document.getElementById("myNumber");
    let maxLength = 5; // Limitar a 5 cifras
    // Verificar la longitud del número ingresado y recortar si excede el límite
    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength); // Recorta a 5 dígitos
    }
  }
  return (
    <>
      <div
        className="InputForm"
        style={{
          display:
            param?.varEditarVisible === 2
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : "none"
              : !param.conf.visible,
          gridColumn: param?.conf?.rellenaFila ? "1 / -1" : "",
          // display: param?.conf.visible
          //   ? param?.varvisible === ""
          //       ? ""
          //       : param?.valdependencia==="" && param?.valexcluyente===""
          //         ? ""
          //         : param?.valdependencia!==""
          //           ? ((param?.valdependencia).includes(param?.variables[param?.varvisible]) ? "":"none")
          //           : (!(param?.valexcluyente).includes(param?.variables[param?.varvisible]) ? "":"none")
          //   : "none",
        }}>
        <label htmlFor={param.conf.id}>{param?.data.placeholder}</label>
        <input
          type="number"
          disabled={
            param?.varEditarVisible === 1
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : "none"
              : !param.conf.editable
          } // disabled={!param.conf.editable}
          {...(param?.conf.id ? { name: param.conf.id } : {})}
          {...(param?.conf.id ? { id: param.conf.id } : {})}
          {...(param?.conf.className ? { className: param.conf.className } : {})}
          {...(param?.conf.min ? { min: param.conf.min } : {})}
          {...(param?.conf.max ? { max: param.conf.max } : {})}
          {...(param?.valorescampos ? { value: param.variables[param.conf.className] } : {})}
          {...(param?.onChange ? { onChange: param.onChange } : {})}
          {...(param?.onBlur ? { onBlur: param.onBlur } : {})}
        />
      </div>
    </>
  );
};

export const CheckboxForm = (param) => {
  return (
    <div
      className="CheckboxForm"
      style={{
        display:
            param?.varEditarVisible === 2
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : "none"
              : !param.conf.visible,
          gridColumn: param?.conf?.rellenaFila ? "1 / -1" : "",
        // display: param?.conf.visible
        //   ? param?.varvisible === ""
        //     ? ""
        //     : param?.valdependencia === "" && param?.valexcluyente === ""
        //       ? ""
        //       : param?.valdependencia !== ""
        //         ? (param?.valdependencia).includes(param?.variables[param?.varvisible])
        //           ? ""
        //           : "none"
        //         : !(param?.valexcluyente).includes(param?.variables[param?.varvisible])
        //           ? ""
        //           : "none"
        //   : "none",
      }}>
      <div>
        <label htmlFor={param.conf.id}>{param?.data.placeholder}</label>
        <label>
          <input
            type="checkbox"
            disabled={
            param?.varEditarVisible === 1
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : true
              : !param.conf.editable
          }
            // disabled={!param.conf.editable}
            {...(param?.onBlur ? { onBlur: param.onBlur } : {})}
            {...(param?.conf.id ? { id: param.conf.id } : {})}
            {...(param?.conf.className ? { className: param.conf.className } : {})}
            {...(param?.data ? { checked: param.valorescampos[param.conf.id] } : {})}
            {...(param?.onChange ? { onChange: param.onChange } : {})}
          />
          <span>{""}</span>
        </label>
      </div>
    </div>
  );
};

export const RadiobuttonForm = (param) => {
  return (
    <div
      className="RadiobuttonForm"
      style={{
        display: param?.conf.visible
          ? param?.varvisible === ""
            ? ""
            : param?.valdependencia === "" && param?.valexcluyente === ""
              ? ""
              : param?.valdependencia !== ""
                ? (param?.valdependencia).includes(param?.variables[param?.varvisible])
                  ? ""
                  : "none"
                : !(param?.valexcluyente).includes(param?.variables[param?.varvisible])
                  ? ""
                  : "none"
          : "none",
      }}>
      <div>
        <span>{param?.data?.placeholder}</span>
        {param?.data?.opciones?.map((op) => {
          return (
            <label key={op.valor}>
              <input
                type="radio"
                disabled={!param.conf.editable}
                {...(param?.conf.id ? { id: param.conf.id } : {})}
                {...(param?.conf.className ? { className: param.conf.className } : {})}
                {...(param?.data ? { checked: param.valorescampos[param.conf.id] == op.valor } : {})}
                {...(param?.data ? { value: op.valor } : {})}
                {...(param?.conf.id ? { name: param.conf.id } : {})}
                {...(param?.onChange ? { onChange: param.onChange } : {})}
              />
              <span>{op.descripcion}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export const OptionForm = (param) => {
  return (
    <div
      className="OptionForm"
      style={{
        display:
            param?.varEditarVisible === 2
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : "none"
              : !param.conf.visible,
          gridColumn: param?.conf?.rellenaFila ? "1 / -1" : "",
        // display: param?.conf.visible
        //   ? param?.varvisible === ""
        //     ? ""
        //     : param?.valdependencia === "" && param?.valexcluyente === ""
        //       ? ""
        //       : param?.valdependencia !== ""
        //         ? (param?.valdependencia).includes(param?.variables[param?.varvisible])
        //           ? ""
        //           : "none"
        //         : !(param?.valexcluyente).includes(param?.variables[param?.varvisible])
        //           ? ""
        //           : "none"
        //   : "none",
      }}>
      <div>
        <label htmlFor={param.conf.id}> {param.data.placeholder} </label>
        <select
          id={param.conf.id}
          {...(param?.conf.className ? { className: param.conf.className } : {})}
          {...(param?.onChange ? { onChange: param.onChange } : {})}
          defaultValue={param.variables[param.conf.className]}
          disabled={
            param?.varEditarVisible === 1
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : "none"
              : !param.conf.editable
          }
          // disabled={!param.conf.editable}
          {...(param?.onBlur ? { onBlur: param.onBlur } : {})}>
          <option value=""></option>
          {param?.data?.opciones?.map((op) => {
            if (param?.vardependencia !== "" && param?.variables[param?.vardependencia] === op.variabledependencia) {
              return (
                <option key={op.valor} value={op.valor}>
                  {op.descripcion}
                </option>
              );
            } else if (param?.vardependencia !== "" && param?.valdependencia !== "") {
              return (
                <option key={op.valor} value={op.valor}>
                  {op.descripcion}
                </option>
              );
            } else if (param?.vardependencia === "") {
              return (
                <option key={op.valor} value={op.valor}>
                  {op.descripcion}
                </option>
              );
            }
          })}
        </select>
      </div>
    </div>
  );
};

export const DateForm = (param) => {
  return (
    <>
      <div
        className="DateForm"
        style={{
          display:
            param?.varEditarVisible === 2
              ? param?.conf.visible
                ? obtenerPropiedad(param, param?.varvisible)
                : "none"
              : !param.conf.visible,
          gridColumn: param?.conf?.rellenaFila ? "1 / -1" : "",
          // display: param?.conf.visible
          //   ? param?.varvisible === ""
          //     ? ""
          //     : param?.valdependencia === "" && param?.valexcluyente === ""
          //       ? ""
          //       : param?.valdependencia !== ""
          //         ? (param?.valdependencia).includes(param?.variables[param?.varvisible])
          //           ? ""
          //           : "none"
          //         : !(param?.valexcluyente).includes(param?.variables[param?.varvisible])
          //           ? ""
          //           : "none"
          //   : "none",
        }}>
        <div>
          <label htmlFor={param.conf.id}>{param?.data.placeholder}</label>
          <input
            type="Date"
            disabled={!param.conf.editable}
            {...(param?.conf.id ? { name: param.conf.id } : {})}
            {...(param?.conf.id ? { id: param.conf.id } : {})}
            {...(param?.conf.className ? { className: param.conf.className } : {})}
            {...(param?.data ? { value: param.variables[param.conf.className] } : {})}
            {...(param?.onChange ? { onChange: param.onChange } : {})}
          />
        </div>
      </div>
    </>
  );
};

/*
============================================================
Elementos V1 -> asucasaire -> filtros
Los datos necesarios son campofiltro, visibile, onChange
============================================================
*/
export const InputFilter = (param) => {
  return (
    <>
      <div className="inpuFilter" style={{ display: param.visible ? "" : "none" }}>
        <label htmlFor={param.campofiltro}>{param.campofiltro}</label>
        <input
          type="text"
          {...(param?.campofiltro ? { id: param.campofiltro } : {})}
          // {...(param?.campofiltro ? { placeholder: param.campofiltro } : {})}
          {...(param?.onChange ? { onChange: param.onChange } : {})}
          {...(param?.valoresfiltros ? { value: param.valoresfiltros[param.campofiltro] } : {})}
        />
      </div>
    </>
  );
};

export const CheckboxFilter = (param) => {
  return (
    <>
      <div style={{ display: param.visible ? "" : "none" }}>
        <label htmlFor={param.campofiltro}>{param.campofiltro}</label>
        <input
          type="checkbox"
          {...(param?.campofiltro ? { id: param.campofiltro } : {})}
          {...(param?.campofiltro ? { placeholder: param.campofiltro } : {})}
          {...(param?.onChange ? { onChange: param.onChange } : {})}
        />
      </div>
    </>
  );
};

export const RadiobuttonFilter = () => {};
export const OptionFilter = () => {};
export const DateFilter = () => {};

//ELEMENTOS GENÉRICOS
export const Option = (param) => {
  const { esComputadora, rol, usuariosesion, codRol } = useContext(Contexto);
  const [opciones, setopciones] = useState(null);
  const [muestroopciones, setmuestroopciones] = useState(false);
  const [dentroOpt, setDentroOpt] = useState(false);
  const [optSelec, setOptSelec] = useState("");
  const [dscOptSelc, setDscOptSelc] = useState("");
  const [optfiltro, setoptfiltro] = useState(null);
  useEffect(() => {
    if (param.opciones !== null) {
      setopciones(param.opciones);
      setoptfiltro(param.opciones);
    }
  }, [param.opciones]);

  useEffect(() => {
    if (opciones !== null) {
      setoptfiltro(
        opciones.filter((f) => {
          return param.valor
            .reduce((acc, val) => {
              return acc + f[val] + " ";
            }, "")
            .toUpperCase()
            .includes(dscOptSelc.toUpperCase());
        }),
      );
    }
  }, [dscOptSelc]);

  return (
    <>
      <style.Contenido $escomputadora={esComputadora}>
        <label className={"labelInputSelectGenerico"}>{param.placeholder}</label>
        <input
          className={"inputSelectGenerico"}
          type="text"
          value={dscOptSelc}
          onClick={() => {
            if (muestroopciones) setmuestroopciones(false);
            else setmuestroopciones(true);
          }}
          onChange={(e) => {
            setDscOptSelc(e.currentTarget.value);
            setmuestroopciones(true);
          }}
          onBlur={() => {
            if (!dentroOpt) setmuestroopciones(false);
          }}
        />
        <div
          className={`SelectGenerico ${muestroopciones ? "" : "mostrarSelectGenerico"}`}
          onMouseEnter={() => {
            setDentroOpt(true);
          }}
          onMouseLeave={() => {
            setDentroOpt(false);
          }}
          onBlur={() => {
            setDentroOpt(false);
          }}>
          <div
            className="optionGenerico"
            id=""
            onClick={(e) => {
              setDscOptSelc(e.currentTarget.innerText.trim());
              setOptSelec(e.currentTarget.id.trim());
              param.onClick(e.currentTarget.id.trim());
              setmuestroopciones(false);
            }}>
            &nbsp;
          </div>
          {optfiltro &&
            optfiltro.map((opciones, index) => {
              return (
                <div
                  key={index}
                  className="optionGenerico"
                  id={param.clave.reduce((acc, val) => {
                    return acc + opciones[val]; // + ",";
                  }, "")}
                  onClick={(e) => {
                    setDscOptSelc(e.currentTarget.innerText.trim());
                    setOptSelec(e.currentTarget.id.trim());
                    param.onClick(e.currentTarget.id.trim());
                    setmuestroopciones(false);
                  }}>
                  {_f_.capitalizar_palabra(
                    param.valor.reduce((acc, val) => {
                      return acc + opciones[val] + " ";
                    }, ""),
                  )}
                </div>
              );
            })}
        </div>
      </style.Contenido>
    </>
  );
};
